import React from "react";
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      title: t('process.step1Title'),
      description: t('process.step1Desc'),
      img: "assets/images/homepage/process_01.png",
    },
    {
      id: 2,
      title: t('process.step2Title'),
      description: t('process.step2Desc'),
      img: "assets/images/homepage/process_02.png",
    },
    {
      id: 3,
      title: t('process.step3Title'),
      description: t('process.step3Desc'),
      img: "assets/images/homepage/process_03.png",
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h4 className="text-yellow-500 text-xl uppercase font-bold leading-tight tracking-tighter">Processes</h4>
          <div className="w-16 h-1 bg-yellow-500 mx-auto my-2"></div>
          <h2 className="text-4xl md:text-4xl font-bold">{t('process.title')}</h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center mb-10">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className="flex flex-col items-center transition hover:scale-105 duration-300 bg-gray-50 py-10 px-6"
            >
              <img
                src={step.img}
                alt={step.title}
                className="w-24 h-24 md:w-32 md:h-32 mb-4"
              />
              <h3 className="text-2xl font-light mb-2 opacity-[0.8]">{step.title}</h3>
              <p className="text-gray-600 text-md max-w-sm">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="text-center">
          <a
            href="#"
            className="inline-block bg-yellow-500 text-white font-semibold px-6 py-3 rounded-[100px] hover:bg-yellow-600 transition"
          >
            {t('process.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
